import IntegrationEvents from '../../services/rest/IntegrationEvents';
import { createRestSlices, applyReducers } from './rest';

const REPLAYING_WEBHOOK          = `pixoo/integration_events/REPLAYING_WEBHOOK`;
const REPLAYING_WEBHOOK_SUCCESS  = `pixoo/integration_events/REPLAYING_WEBHOOK_SUCCESS`;
const REPLAYING_WEBHOOK_FAILURE  = `pixoo/integration_events/REPLAYING_WEBHOOK_FAILURE`;
const REPLAYING_CALLBACK         = `pixoo/integration_events/REPLAYING_CALLBACK`;
const REPLAYING_CALLBACK_SUCCESS = `pixoo/integration_events/REPLAYING_CALLBACK_SUCCESS`;
const REPLAYING_CALLBACK_FAILURE = `pixoo/integration_events/REPLAYING_CALLBACK_FAILURE`;

const replayReducer = (state, action) => {
    switch (action.type) {
        case REPLAYING_WEBHOOK:
        case REPLAYING_CALLBACK:
            return {
                ...state,
                isReplaying: true,
                replayError: null,
            };
        case REPLAYING_WEBHOOK_SUCCESS:
        case REPLAYING_CALLBACK_SUCCESS:
            return {
                ...state,
                isReplaying: false,
                replayError: null,
                lastReplayDelivery: action.delivery,
            };
        case REPLAYING_WEBHOOK_FAILURE:
        case REPLAYING_CALLBACK_FAILURE:
            return {
                ...state,
                isReplaying: false,
                replayError: action.error.message,
            };
        default:
            return state;
    }
};

function replayingWebhook() { return { type: REPLAYING_WEBHOOK }; }
function replayingWebhookSuccess(delivery) { return { type: REPLAYING_WEBHOOK_SUCCESS, delivery }; }
function replayingWebhookFailure(err) { return { type: REPLAYING_WEBHOOK_FAILURE, error: err }; }

function replayingCallback() { return { type: REPLAYING_CALLBACK }; }
function replayingCallbackSuccess(delivery) { return { type: REPLAYING_CALLBACK_SUCCESS, delivery }; }
function replayingCallbackFailure(err) { return { type: REPLAYING_CALLBACK_FAILURE, error: err }; }

export const replayWebhook = (deliveryId) => {
    return (dispatch) => {
        dispatch(replayingWebhook());
        return IntegrationEvents.replayWebhook(deliveryId)
            .then((data) => {
                dispatch(replayingWebhookSuccess(data.integration_delivery));
            })
            .catch((err) => {
                dispatch(replayingWebhookFailure(err));
            });
    };
};

export const replayCallback = (deliveryId) => {
    return (dispatch) => {
        dispatch(replayingCallback());
        return IntegrationEvents.replayCallback(deliveryId)
            .then((data) => {
                dispatch(replayingCallbackSuccess(data.integration_delivery));
            })
            .catch((err) => {
                dispatch(replayingCallbackFailure(err));
            });
    };
};

const {
    initialState,
    getReducer,
    listReducer,
    getAction,
    listAction,
} = createRestSlices(IntegrationEvents);

const mergedInitialState = {
    ...initialState,
    integration_events: [],
    integration_event: null,
    isReplaying: false,
    replayError: null,
    lastReplayDelivery: null,
};

export default (state = mergedInitialState, action) => {
    return applyReducers(state, action, [
        getReducer,
        listReducer,
        replayReducer,
    ]);
};

export const loadIntegrationEvent = getAction;
export const loadIntegrationEvents = listAction;
